@if ((content | translate) && !isNotFound) {
    <section id="legal-screen" [innerHTML]="content | translate"></section>
}
@if (isNotFound) {
    <app-no-route></app-no-route>
}
